module.exports = __webpack_public_path__ + "static/img/clients-login-background-city-3960x2160.11c84fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients-login-background-city-3960x2160.jpg
// module id = hywu
// module chunks = 22